import React from "react";
import {
  toEnglishNum,
  toPersianNum,
  toPureNum,
  toSeperatedNum,
} from "../../assets/utils";
import { SmallInputStyled } from "./smallInput.styles";

const SmallInput = ({
  setTheState,
  selectTheState,

  placeHolder,
  label,
  ...others
}) => {
  const handle_input_change = (e) => {
    const value = toPureNum(e.currentTarget.value);
    setTheState(toEnglishNum(value));
  };

  return (
    <SmallInputStyled {...others}>
      <input
        onChange={(e) => handle_input_change(e)}
        className="w-100"
        type="text"
        inputMode="tel"
        placeholder={placeHolder}
        value={toSeperatedNum(toPersianNum(selectTheState))}
        maxLength="3"
      />
      <div className="small-input__label">{label}</div>
    </SmallInputStyled>
  );
};

export default SmallInput;
